import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const numberFormats = {
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'code',
      minimumIntegerDigits: 2
    }
  }
};

// Ready translated locale messages
const messages = {
  fr: {
    map: {
      accessBy: 'Accès par'
    }
  }
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages, // set locale messages
  numberFormats
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js